'use client'
import { Typography } from 'components/Contentful'

export default function ValuePropsFooter({ disclaimer, idContent }) {
  return (
    <>
      {disclaimer && (
        <Typography
          content={disclaimer?.textContent}
          variant="bodyXs"
          className="max-w-[808px] text-center text-[#42546b] m-auto pt-12"
          data-testid={`value-prop-2-disclaimer-${idContent}`}
        />
      )}
    </>
  )
}
